<template>
    <label :class="{ 'checked': currentValue == id || isChecked }">
        <img :src="imgSrc" />
        <input type="checkbox" :name="name" :info="info" :value="value" :type="type" :id="id" @click="checkboxClicked" />
        <span class="check"></span>
        <div class="text">
            <slot></slot>
        </div>
        <span class="price">
            &euro; {{price}}
        </span>
    </label>
</template>

<script>
    export default {
        name: "ext-checkbox",
        props: {
            name: String,
            id: Number,
            value: {},
            price: Number,
            info: String,
            imgSrc: String,
            type: String,
            currentValue: {},
            defaultChecked: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isChecked: false,
            }
        },
        methods: {
            checkboxClicked: function() {
                var object = {
                    value: this.value,
                    id: this.id,
                    info: this.info,
                    price: this.price,
                    name: this.name,
                    imgSrc: this.imgSrc,
                    type: this.type
                };
                this.$emit('kaderOptie', object);
                this.isChecked = !this.isChecked;
            }
        },
        mounted: function () {

            if (this.defaultChecked || this.currentValue == this.id) {
                this.checkboxClicked()
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/ExtCheckbox.vue